const middleware = {}

middleware['is-canceled'] = require('../client/middleware/is-canceled.js')
middleware['is-canceled'] = middleware['is-canceled'].default || middleware['is-canceled']

middleware['is-subscriber'] = require('../client/middleware/is-subscriber.js')
middleware['is-subscriber'] = middleware['is-subscriber'].default || middleware['is-subscriber']

middleware['is-trial'] = require('../client/middleware/is-trial.js')
middleware['is-trial'] = middleware['is-trial'].default || middleware['is-trial']

middleware['is-user'] = require('../client/middleware/is-user.js')
middleware['is-user'] = middleware['is-user'].default || middleware['is-user']

middleware['not-subscriber'] = require('../client/middleware/not-subscriber.js')
middleware['not-subscriber'] = middleware['not-subscriber'].default || middleware['not-subscriber']

middleware['not-user'] = require('../client/middleware/not-user.js')
middleware['not-user'] = middleware['not-user'].default || middleware['not-user']

middleware['old-categories'] = require('../client/middleware/old-categories.js')
middleware['old-categories'] = middleware['old-categories'].default || middleware['old-categories']

middleware['quiz'] = require('../client/middleware/quiz.js')
middleware['quiz'] = middleware['quiz'].default || middleware['quiz']

export default middleware
